/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SavedFieldMapping
 */
export interface SavedFieldMapping {
    /**
     * 
     * @type {string}
     * @memberof SavedFieldMapping
     */
    stotlesField: string;
    /**
     * 
     * @type {string}
     * @memberof SavedFieldMapping
     */
    crmField: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SavedFieldMapping
     */
    targetEntitySets?: Array<string>;
}

/**
 * Check if a given object implements the SavedFieldMapping interface.
 */
export function instanceOfSavedFieldMapping(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stotlesField" in value;
    isInstance = isInstance && "crmField" in value;

    return isInstance;
}

export function SavedFieldMappingFromJSON(json: any): SavedFieldMapping {
    return SavedFieldMappingFromJSONTyped(json, false);
}

export function SavedFieldMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavedFieldMapping {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stotlesField': json['stotlesField'],
        'crmField': json['crmField'],
        'targetEntitySets': !exists(json, 'targetEntitySets') ? undefined : json['targetEntitySets'],
    };
}

export function SavedFieldMappingToJSON(value?: SavedFieldMapping | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stotlesField': value.stotlesField,
        'crmField': value.crmField,
        'targetEntitySets': value.targetEntitySets,
    };
}

